import { render } from "./AddGameModal.vue?vue&type=template&id=02c85c84&scoped=true"
import script from "./AddGameModal.vue?vue&type=script&lang=js"
export * from "./AddGameModal.vue?vue&type=script&lang=js"

import "./AddGameModal.vue?vue&type=style&index=0&id=02c85c84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c85c84"]])

export default __exports__